<template>
  <div class="gender-selector" v-show="primaryGender !== 'unisex'">
    <div
      class="gender-selector__toggle"
      :class="
        selectedGender === primaryGender
          ? 'gender-selector__toggle--selected'
          : 'gender-selector__toggle--unselected'
      "
      @click="switchGender(primaryGender)"
    >
      <div class="gender-selector__toggle-text">
        {{ $t(`pdp.purchase_pod.${primaryGender}`) }}
      </div>
    </div>
    <div
      v-show="secondaryGenderHasVariants"
      class="gender-selector__toggle gender-selector__toggle--secondary"
      :class="
        selectedGender === secondaryGender
          ? 'gender-selector__toggle--selected'
          : 'gender-selector__toggle--unselected'
      "
      @click="switchGender(secondaryGender)"
    >
      <div class="gender-selector__toggle-text" ref="toggleText">
        {{ $t(`pdp.purchase_pod.${secondaryGender}`) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GENDERS } from '@/stores/product'

export default {
  name: 'GenderSelector',
  data() {
    return {
      isHidden: false,
      primaryGender: GENDERS.default,
    }
  },

  computed: {
    ...mapState('product', ['selectedGender']),

    ...mapGetters({
      firstMaleVariantId: 'product/firstMaleVariantId',
      firstFemaleVariantId: 'product/firstFemaleVariantId',
    }),

    secondaryGender() {
      return this.primaryGender === GENDERS.mens ? GENDERS.womens : GENDERS.mens
    },

    secondaryGenderHasVariants() {
      return this.primaryGender === GENDERS.mens
        ? !!this.firstFemaleVariantId
        : !!this.firstMaleVariantId
    },
  },
  created() {
    this.primaryGender = this.selectedGender
  },

  methods: {
    ...mapActions({
      handleGenderSwitch: 'product/handleGenderSwitch',
    }),

    switchGender(genderToSelect) {
      this.handleGenderSwitch(genderToSelect)
      this.$emit('switch-gender')
    },
  },
}
</script>

<style lang="scss" scoped>
.gender-selector {
  display: flex;

  &__toggle {
    user-select: none;
    font-size: $font-size-xsmall;
    font-weight: bold;
    letter-spacing: 0.179em;
    text-transform: uppercase;
    transition: color $transition-time-slower ease-in-out;

    @media ($mq-large) {
      font-size: $font-size-smaller;
    }

    &--selected {
      padding: 12px 0;
      border-bottom: 2px solid $color-green;
      cursor: default;
    }

    &--unselected {
      flex: 1;
      border-bottom: 1px solid $color-grey-mid-1;
      cursor: pointer;
      color: $color-grey-mid-2;
      transition: color $transition-time;

      &:hover {
        color: $color-grey-dark-2;
      }

      .gender-selector__toggle-text {
        position: relative;
        top: 12px;
      }
    }

    &--secondary {
      text-align: right;
    }
  }
}
</style>
